import React, { useEffect, useRef, useState } from "react";
import { Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";

const tournamentList = [
  { name: "Team A" },
  { name: "Team B" },
  { name: "Team C" },
];

const allPlayersList = [
  {
    name: "Rohit Sharma",
    phone: "9876543210",
    fee: 1500,
    feeStatus: "Paid",
    tournament: "Champions Trophy 2025",
  },
  {
    name: "Virat Kohli",
    phone: "9123456780",
    fee: 1500,
    feeStatus: "Pending",
    tournament: "Champions Trophy 2025",
  },
  {
    name: "Hardik Pandya",
    phone: "9998887776",
    fee: 1000,
    feeStatus: "Paid",
    tournament: "Summer League 2025",
  },
];

const AllTournamentsPlayers = () => {
  const [selectedTournament, setSelectedTournament] = useState(
    "Champions Trophy 2025"
  );
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [feeData, setFeeDate] = useState([]);
  const [newPlayer, setNewPlayer] = useState({
    name: "",
    phone: "",
    fee: "",
    feeStatus: "Pending",
  });
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  useEffect(() => {
    if (selectedTournament) {
      const players = allPlayersList.filter(
        (p) => p.tournament === selectedTournament
      );
      setFilteredPlayers(players);
      setFeeDate(players);
    }
  }, [selectedTournament]);

  // 🏆 Tournament selection
  const handleTournamentSelect = (e) => {
    const tName = e.target.value;
    setSelectedTournament(tName);

    const players = allPlayersList.filter((p) => p.tournament === tName);
    setFilteredPlayers(players);
    setFeeDate(players);
  };

  // 🔍 Search filter
  const DataSearch = (e) => {
    const updatesDate = filteredPlayers.filter((item) => {
      let selectdata =
        `${item.name} ${item.phone} ${item.fee} ${item.feeStatus}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setFeeDate([...updatesDate]);
  };

  // 🔼 Sorting
  function SotingData(name) {
    const sortedPeople = [...feeData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name)
        );
        break;
      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.phone.localeCompare(b.phone)
            : b.phone.localeCompare(a.phone)
        );
        break;
      case "fee":
        sortedPeople.sort((a, b) =>
          iconData.complete ? a.fee - b.fee : b.fee - a.fee
        );
        break;
      case "feeStatus":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.feeStatus.localeCompare(b.feeStatus)
            : b.feeStatus.localeCompare(a.feeStatus)
        );
        break;
      default:
        break;
    }
    setFeeDate(sortedPeople);
  }

  // 🧾 Add new player
  const handleAddPlayer = (e) => {
    e.preventDefault();
    if (!newPlayer.name || !newPlayer.phone || !newPlayer.fee) {
      alert("Please fill all fields");
      return;
    }

    const added = {
      ...newPlayer,
      tournament: selectedTournament,
    };

    const updatedPlayers = [...feeData, added];
    setFeeDate(updatedPlayers);
    setFilteredPlayers(updatedPlayers);

    // Reset form
    setNewPlayer({
      name: "",
      phone: "",
      fee: "",
      feeStatus: "Pending",
    });
  };

  const theadData = [
    { heading: "Name", sortingVale: "name" },
    { heading: "Phone", sortingVale: "phone" },
    { heading: "Fee", sortingVale: "fee" },
    { heading: "Fee Status", sortingVale: "feeStatus" },
    { heading: "Action", sortingVale: "" },
  ];

  return (
    <>
      <PageTitle activeMenu={"All Players"} motherMenu={"Tournaments"} />

      <div className="row mb-3">
        <div className="col-lg-4">
          <label className="form-label">Select Team:</label>
          <select
            className="form-control"
            value={selectedTournament}
            onChange={handleTournamentSelect}
          >
            <option value="">-- Select Team --</option>
            {tournamentList.map((t, i) => (
              <option key={i} value={t.name}>
                {t.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {selectedTournament && (
        <>
          {/* ================== ADD PLAYER FORM ================== */}
          <div className="card mb-4">
            <div className="card-header">
              <h4 className="card-title">Add Player to {selectedTournament}</h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleAddPlayer} className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">Player Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newPlayer.name}
                    onChange={(e) =>
                      setNewPlayer({ ...newPlayer, name: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newPlayer.phone}
                    onChange={(e) =>
                      setNewPlayer({ ...newPlayer, phone: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Fee</label>
                  <input
                    type="number"
                    className="form-control"
                    value={newPlayer.fee}
                    onChange={(e) =>
                      setNewPlayer({ ...newPlayer, fee: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Fee Status</label>
                  <select
                    className="form-control"
                    value={newPlayer.feeStatus}
                    onChange={(e) =>
                      setNewPlayer({ ...newPlayer, feeStatus: e.target.value })
                    }
                  >
                    <option value="Paid">Paid</option>
                    <option value="Pending">Pending</option>
                  </select>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                  <button type="submit" className="btn btn-primary w-100">
                    Add Player
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* ================== PLAYER LIST ================== */}
          <div className="card">
            <div className="card-header d-flex justify-content-between">
              <h4 className="card-title">Players in {selectedTournament}</h4>

              <div className="dataTables_filter">
                <label>
                  Search :{" "}
                  <input
                    type="search"
                    className=""
                    placeholder=""
                    onChange={DataSearch}
                  />
                </label>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped align-middle">
                  <thead>
                    <tr>
                      {theadData.map((item, ind) => (
                        <th
                          key={ind}
                          onClick={() => {
                            SotingData(item.sortingVale);
                            setIconDate((prev) => ({
                              complete: !prev.complete,
                              ind: ind,
                            }));
                          }}
                          style={{ cursor: item.sortingVale ? "pointer" : "" }}
                        >
                          {item.heading}
                          <span>
                            {ind !== iconData.ind && (
                              <i
                                className="fa fa-sort ms-2 fs-12"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                            {ind === iconData.ind &&
                              (iconData.complete ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-12"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-12"
                                  style={{ opacity: "0.7" }}
                                />
                              ))}
                          </span>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {feeData.map((data, ind) => (
                      <tr key={ind}>
                        <td>{data.name}</td>
                        <td>{data.phone}</td>
                        <td>₹{data.fee}</td>
                        <td>
                          <span
                            className={`badge ${
                              data.feeStatus === "Paid"
                                ? "bg-success"
                                : "bg-warning"
                            }`}
                          >
                            {data.feeStatus}
                          </span>
                        </td>
                        <td>
                          <Link
                            to={"#"}
                            className="btn btn-xs sharp btn-primary me-1"
                          >
                            <i className="fa fa-pencil" />
                          </Link>
                          <Link
                            to={"#"}
                            className="btn btn-xs sharp btn-danger"
                          >
                            <i className="fa fa-trash" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AllTournamentsPlayers;
